import { render, staticRenderFns } from "./adminRoomFeeList.vue?vue&type=template&id=6d8f2ba8&scoped=true"
import script from "./adminRoomFeeList.vue?vue&type=script&lang=js"
export * from "./adminRoomFeeList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomFeeList.vue?vue&type=style&index=0&id=6d8f2ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f2ba8",
  null
  
)

export default component.exports